import { Navigate, useParams } from 'react-router-dom';

/**
 * Legacy booking URLs used …/book-appointment/:slug. Canonical path is …/:slug?book=1
 */
const StorefrontBookAppointmentLegacyRedirect = () => {
  const { companyUrl, serviceSlug } = useParams();
  if (!companyUrl) {
    return <Navigate to="/book" replace />;
  }
  if (serviceSlug) {
    return (
      <Navigate
        to={`/book/${companyUrl}/${encodeURIComponent(serviceSlug)}?book=1`}
        replace
      />
    );
  }
  return <Navigate to={`/book/${companyUrl}`} replace />;
};

export default StorefrontBookAppointmentLegacyRedirect;
